import React from 'react'

import { Field } from 'formik'

import { Table, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const PrecioCell = ({ row, dispatch, iError, iTouched, handleChange }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      dispatch({
        type: 'actualizar',
        payload: {
          ...row,
          precio: e.target.value
        }
      })
    },
    [handleChange, dispatch, row]
  )

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(`${row._idFila}-idSocio`, e)
    },
    [row]
  )

  return (
    <Table.Cell>
      <Field name='precio'>
        {({ field }) => (
          <Form.InputNumber
            {...field}
            id={`${row._idFila}-precio`}
            isInvalid={iTouched && iError}
            onChange={onChange}
            onKeyDown={onKeyDown}
            disabled
          />
        )}
      </Field>
    </Table.Cell>
  )
}

export default React.memo(PrecioCell)
